var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path, _path2, _path3, _circle9, _circle10, _circle11, _circle12, _path4, _path5, _path6, _circle13, _circle14, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotFoundIcon = function SvgNotFoundIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 91,
    viewBox: "0 0 282 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0197,
    cy: 12.9843,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.0197,
    cy: 78.3542,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4399,
    cy: 56.5641,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.8092,
    cy: 56.5641,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.136,
    cy: 45.6692,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.506,
    cy: 45.6692,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.821,
    cy: 12.9843,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.821,
    cy: 78.3542,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.54492 56.5641C1.54492 50.547 6.42275 45.6692 12.4399 45.6692H77.8095C83.8266 45.6692 88.7045 50.547 88.7045 56.5641C88.7045 62.5812 83.8266 67.4591 77.8095 67.4591H12.4399C6.42275 67.4591 1.54492 62.5812 1.54492 56.5641Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0197 89.249C50.0026 89.249 45.1248 84.3712 45.1248 78.3541L45.1248 12.9844C45.1248 6.96732 50.0026 2.08948 56.0197 2.08948C62.0368 2.08948 66.9146 6.96731 66.9146 12.9844L66.9146 78.3541C66.9146 84.3712 62.0368 89.249 56.0197 89.249Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89041 64.1881C0.635671 59.9334 0.635671 53.0351 4.89041 48.7804L48.2351 5.43563C52.4899 1.1809 59.3882 1.18089 63.6429 5.43563C67.8977 9.69037 67.8977 16.5887 63.6429 20.8434L20.2982 64.1881C16.0434 68.4429 9.14515 68.4429 4.89041 64.1881Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.77,
    cy: 12.9843,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.77,
    cy: 78.3542,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 204.191,
    cy: 56.5641,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 269.56,
    cy: 56.5641,
    r: 10.8949,
    stroke: "#667085",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.296 56.5641C193.296 50.547 198.174 45.6692 204.191 45.6692H269.56C275.578 45.6692 280.455 50.547 280.455 56.5641C280.455 62.5812 275.578 67.4591 269.56 67.4591H204.191C198.174 67.4591 193.296 62.5812 193.296 56.5641Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M247.77 89.249C241.753 89.249 236.875 84.3712 236.875 78.3541L236.875 12.9844C236.875 6.96732 241.753 2.08948 247.77 2.08948C253.787 2.08948 258.665 6.96731 258.665 12.9844L258.665 78.3541C258.665 84.3712 253.787 89.249 247.77 89.249Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.642 64.1881C192.387 59.9334 192.387 53.0351 196.642 48.7804L239.986 5.43563C244.241 1.1809 251.139 1.18089 255.394 5.43563C259.649 9.69037 259.649 16.5887 255.394 20.8434L212.049 64.1881C207.795 68.4429 200.896 68.4429 196.642 64.1881Z",
    stroke: "#667085",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.821,
    cy: 45.6691,
    r: 43.5798,
    stroke: "#667085",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 138.821,
    cy: 45.6694,
    r: 21.7899,
    stroke: "#667085",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 1.08936,
    x2: 280.455,
    y2: 1.08938,
    stroke: "#667085",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 89.3384,
    x2: 280.455,
    y2: 89.3384,
    stroke: "#667085",
    strokeWidth: 2
  })));
};
export default SvgNotFoundIcon;